import { FunctionComponent } from 'react';

import { ErrorModal, ErrorToast } from 'shared-ui';

type Props = {
  error: Error;
};

export const ErrorBoundaryFallback: FunctionComponent<Props> = ({ error }) => {
  return <ErrorModal error={error} />;
};
